import { nextTick } from 'vue';

import { HandlerMessagesCommonOptions } from '@/types/composables';
import { MessageText } from '@/types/socket';

export function useMessageTextCommon({ contentContainer }: HandlerMessagesCommonOptions) {
  let isUpdatingHeight = false; // 지금 높이조절 중인지
  let markerHeightLast = 0; // 이전 높이

  // 메세지가 변할 시 충분한 여백 확보
  const updateContainerHeight = async (
    minIncrement: number,
    isMandatory: boolean = false // 강제로 늘리기 여부
  ) => {
    if (isUpdatingHeight) return; // 중복으로 조절되는 것 방지
    isUpdatingHeight = true;
    await nextTick();
    await new Promise((resolve) => setTimeout(resolve, 0));
    const MAX_SINGLE_STEP = 100;

    const containerEl = contentContainer.value;
    if (!containerEl) return;

    const currentHeight = containerEl.scrollHeight;
    if (isMandatory || currentHeight > Math.round(markerHeightLast)) {
      const diff = currentHeight - markerHeightLast;

      let increment;
      if (diff < minIncrement * 3) {
        // 두줄 씩 늘리기
        increment = minIncrement * 3;
      } else if (diff < MAX_SINGLE_STEP) {
        increment = diff;
      } else {
        increment = MAX_SINGLE_STEP;
      }
      markerHeightLast += increment;
      containerEl.style.minHeight = `${markerHeightLast}px`;
    }
    isUpdatingHeight = false;
  };

  // 메세지 확정 후 불필요 여백 없애기
  const shrinkBubble = async () => {
    await nextTick();
    await new Promise((resolve) => setTimeout(resolve, 0));

    const container = contentContainer.value;
    if (!container) return;

    const scrollHeight = container.scrollHeight;

    container.style.minHeight = '0';
    container.style.height = 'auto';
    markerHeightLast = scrollHeight;
  };

  // 문구별 DOM key 생성
  const getKey = (messageDetails: MessageText) =>
    messageDetails.chatSeqSubId + (messageDetails.highlight ? '-incomplete' : '-complete'); // 미확정 재렌더링 방지를 위해 반드시 필요

  return {
    updateContainerHeight,
    shrinkBubble,
    getKey,
  };
}
